import { http, id } from 'utils'
import { SET_CAPABILITIES, SET_RESULT } from 'vx/mutations'
import { findIndex, set } from 'lodash'
const rootGraduate = (rootState, graduate) => id(graduate || rootState.graduates.graduate)
const rootPlacement = (rootState, placement) => id(placement || rootState.placements.placement)

const state = {
  capabilities: []
}

const getters = {}

const actions = {
  async getCapabilities ({ commit, rootState }, { graduate, placement } = {}) {
    commit(SET_CAPABILITIES, [])

    const response = await http.get(`/graduates/${rootGraduate(rootState, graduate)}/placements/${rootPlacement(rootState, placement)}/end-component/capabilities`)

    commit(SET_CAPABILITIES, response.data.data)

    return response
  },

  /**
   * Update capabilities
   *
   * @param object payload
   */
  async storeCapabilities ({ commit, rootState }, { graduate, placement, payload }) {
    const response = await http.post(`/graduates/${rootGraduate(rootState, graduate)}/placements/${rootPlacement(rootState, placement)}/end-component/capabilities`, payload)

    return response
  },

  /**
   * Set the result on a graduate capability
   *
   * @param object payload
   */
  setCapabilityResult ({ commit }, payload) {
    commit(SET_RESULT, payload)
  },

  /**
   * Reset capabilities
   */
  resetCapabilities ({ commit }) {
    commit(SET_CAPABILITIES, [])
  }
}

// Capabilities state mutations.
const mutations = {
  [SET_CAPABILITIES] (state, capabilities) {
    state.capabilities = capabilities
  },

  [SET_RESULT] (state, { property, value, id }) {
    let index = findIndex(state.capabilities, capability => {
      return capability.id === id
    })

    if (index !== -1) {
      set(state.capabilities[index], property, value)
    }
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
